const noWheel = () => {
	window.addEventListener(
		'wheel',
		function (e) {
			if (e.ctrlKey) {
				e.preventDefault();
				console.log('hi');
				return false;
			}
		},
		{ passive: false },
	);
	const body = document.querySelector('body');

	body.addEventListener(
		'touchstart',
		(e) => {
			e.touches.length > 1 ? e.preventDefault() : null;
		},
		{ passive: false },
	);
	if(document.querySelector('.videoBlock')) {
		mainPlug();

	}
}
export default noWheel;